import debounce from 'lodash/debounce'
import fetchPosts from '../fetch/fetch-posts'
import { ARCHIVE_SEARCH } from '../constants'

export default function search (archive) {
    const searchField = archive.querySelector(`[${ARCHIVE_SEARCH}]`)

    if (searchField) {
        searchField.addEventListener('keyup', debounce(() => {
            fetchPosts(archive, searchField)
        }, 400))
    }
}